module.exports = __webpack_public_path__ + "static/media/YF104_3.0363fe94.jpg";